<template>
  <div class="hero">
    <b-badge pill variant="light" class="hero__pill">
      <vb-icon name="sparkle" :color="sass('primary')" :size="16" />
      <span>Gift Card con Welfare Aziendale</span>
    </b-badge>
    <h1 class="hero__title">
      Scegli la Gift Card Vadobay e sblocca i tuoi prossimi viaggi
    </h1>
    <p class="hero__text">
      Trasforma ora il tuo credito welfare in una Gift Card per viaggiare.
      Dove e quando partire lo decidi quando vuoi, nei prossimi {{ validity_months }} mesi.
    </p>
    <p class="hero__note">
      Accedi a centinaia di migliaia di hotel, resort e case vacanze in tutto il mondo.<br />
      Acquisti oggi e pianifichi la tua partenza con la massima calma.
    </p>
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'livegift-hero',

    computed: {
      validity_months: () => VALIDITY_MONTHS,
    },
  };
</script>

<style lang="scss" scoped>

  // intestazione della pagina: tutto centrato in colonna
  .hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &__pill {
      display: inline-flex;
      align-items: center;
      padding: $grid-gutter-width / 3;
      font-size: $font-size-md;
      font-weight: $vb-font-weight-semibold;
      color: $primary;
      background-color: $selected;

      span {
        margin-left: 5px;
      }
    }

    &__title {
      margin: ($grid-gutter-width / 2) 0 0;
      font-size: 30px;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
      color: $gray-900;

      @include media-breakpoint-up(xl) {
        font-size: $font-size-base * 2.25;
        line-height: 40px;
      }
    }

    &__text {
      // larghezza del box di testo nel Figma: manda a capo dopo "usala"
      max-width: 672px;
      margin: ($grid-gutter-width / 2) 0 0;
      font-size: $font-size-lg;
      line-height: normal;
      color: $gray-800;

      @include media-breakpoint-up(xl) {
        font-size: $font-size-xl;
        line-height: 28px;
      }
    }

    &__note {
      margin: $grid-gutter-20 0 0;
      font-size: $font-size-md;
      color: $gray-700;
    }
  }
</style>